import { CalendarHeart } from "lucide-react";
import { DORIE_URL } from "../constants";
import { Reveal } from "./Reveal";

export const Appointment = () => (
    <section
        id="appointment"
        data-testid="appointment-section"
        className="scroll-mt-24 px-5 py-20 lg:px-10 lg:py-28"
    >
        <Reveal>
            <div className="relative mx-auto max-w-5xl overflow-hidden rounded-[2.5rem] bg-miam-dark px-8 py-16 text-center soft-shadow lg:py-24">
                <span
                    className="absolute -top-16 -right-16 h-56 w-56 rounded-full bg-miam-green/20"
                    aria-hidden="true"
                />
                <span
                    className="absolute -bottom-20 -left-16 h-64 w-64 rounded-full bg-miam-rose/25"
                    aria-hidden="true"
                />
                <div className="relative">
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-snug text-miam-cream">
                        جاهزة لمنح نفسك وقتاً{" "}
                        <span className="italic text-[#D9A4B6]">من الراحة؟</span>
                    </h2>
                    <p className="mx-auto mt-6 max-w-xl text-base md:text-lg text-miam-cream/80 leading-relaxed">
                        اختاري العلاج والموعد المناسبين لك بسهولة من خلال نظام
                        حجز المواعيد.
                    </p>
                    <a
                        href={DORIE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="appointment-booking-button"
                        className="mt-10 inline-flex items-center gap-3 rounded-full bg-miam-green px-10 py-5 text-lg font-bold text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-1 hover:bg-miam-green-dark hover:shadow-xl"
                    >
                        <CalendarHeart className="h-6 w-6" aria-hidden="true" />
                        احجزي موعدك الآن
                    </a>
                </div>
            </div>
        </Reveal>
    </section>
);
